import {ThunkAction, Action, configureStore, combineReducers} from '@reduxjs/toolkit';
import {persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER} from 'redux-persist'
import userReducer from "./user.redux";
import chatReducer from "./chat.redux";
import { encryptedStorage } from '../utils/encrypted-storage';

const persistConfig = {
  key: 'root',
  // 本地持久化数据以 AES-GCM 加密落盘(防止明文直接暴露)
  storage: encryptedStorage,
  // 会话数据(聊天消息等)不持久化,刷新后重新拉取
  whitelist: ['user'],
}

const persistedReducer = persistReducer(persistConfig, combineReducers({
  user: userReducer,
  chat: chatReducer,
}))

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})
export const persistor = persistStore(store)


export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
